import React, { Component } from "react";
import {
	MultiSelect,
  Label,
	Range,
	Email,
  Header,
  Rating,
  TextArea,
  DatePick,
  DateTime,
  TimePicker,
  PickList,
  TextInput,
  Paragraph,
  Hyperlink,
	Signature,
  LineBreak,
  CheckBoxes,
  MultiCheckbox,
  NumberInput,
  AutoNumber,
  RadioButtons,
  Currency,
  Percentage,
  FileUpload,
  Lookup,
  MultiLookup,
  PhoneNumber,
  LongNumber,
  Decimal,
  ImageUpload,
  UserField,
  BlankField,
  Reminder,
  PostalCode,
  StepsTypeTag,
  CustomAll,
  CustomAllFiles
} from "./index";
import { onBlurHandlerAction } from "../../../../store/actions/formBuilderActions";

class SwitchItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      typingTimeout: null,
  };
  }
//   changeInputHandler = (obj, evnt, type) => {
//     this.props.onChangeInputAction(obj, evnt, type);

//     if (this.state.typingTimeout) {
//         clearTimeout(this.state.typingTimeout);
//     }
//     this.setState({
//         typingTimeout: setTimeout(() => {
//             this.props.onBlurHandlerAction(obj, evnt, type);
//         }, 500)
//     });
// }
    changeInputHandler = (obj, evnt, type) => {
      const { onChangeInputAction, onBlurHandlerAction } = this.props;
      onChangeInputAction(obj, evnt, type);
      if (this.state.typingTimeout) {
          clearTimeout(this.state.typingTimeout);
      }
      const onblurEvnt = ['User','Lookup','MultiLookup','Reminder','Image','ImageUpload','File','FileUpload','MultiSelect','PickList','Date','DateTime'];
      const newTimeout = setTimeout(() => {
        if(onblurEvnt.indexOf(this.props.item.element)!==-1){
          onBlurHandlerAction(obj, evnt, type);
        }
      }, 700);
      this.setState({ typingTimeout: newTimeout });
    }

  render() {
    
    const item=this.props.item;
    const sectionType=this.props.sectionType;
    const paramState = {
      item:item,
      sectionType:sectionType,
      ...this.props,
      onChangeInputAction:(obj,e,type)=>this.changeInputHandler(obj,e,type),
    }
    //console.log('paramState==',paramState)
    switch (item.element) {
      case "MultiCheckbox":
        return <MultiCheckbox  {...paramState} />;
      case "CheckBoxes":
        return <CheckBoxes {...paramState}/>;  
      case "PickList":
        return <PickList {...paramState}/>;
      case "Phone":  
        return <PhoneNumber {...paramState}/>;  
      case "Header":
        return <Header {...paramState}/>;
      case "HyperLink":
        return <Hyperlink {...paramState}/>;
      case "Label":
        return <Label {...paramState}/>;
      case "LineBreak":
        return <LineBreak {...paramState}/>;
      case "Number":
        return <NumberInput {...paramState}/>;
      case "AutoNumber":
          return <AutoNumber {...paramState} />;  
      case "Paragraph":
        return <Paragraph {...paramState} />;
      case "RadioButtons":
        return <RadioButtons {...paramState} />;
      case "Range":
        return <Range {...paramState} />;
      case "Rating":
        return <Rating {...paramState} />;
      case "MultiSelect":
        return <MultiSelect {...paramState} />;
      case "TextArea":
        return <TextArea {...paramState} />;
      case "TextInput":
        return <TextInput {...paramState} />;
      case "Email":
        return <Email {...paramState} />;
      case "Date":
        return <DatePick {...paramState} />;
      case "DateTime":
        return <DateTime {...paramState} />;
      case "Time":
        return <TimePicker {...paramState} />;      
      case "Signature":
        return <Signature {...paramState} />;
      case "Currency":
        return <Currency {...paramState} />; 
      case "Percentage":
        return <Percentage {...paramState} />;
      case "Decimal":
        return <Decimal {...paramState} />; 
      case "LongNumber":
        return <LongNumber {...paramState} />;    
      case "File":
      case "FileUpload":
        return <FileUpload {...paramState} />;
      case "Image":
      case "ImageUpload":
        return <ImageUpload {...paramState} />;  
      case "Lookup": 
          return <Lookup {...paramState} />;
      case "MultiLookup":
          return <MultiLookup {...paramState} />;  
      case "User":
        return <UserField {...paramState} />;
      case "Blank":
        return <BlankField {...paramState} />;
      case "Reminder":
        return <Reminder {...paramState} />;
      case "PostalCode":
        return <PostalCode {...paramState} />;
      case "StepsTypeTag":
        return <StepsTypeTag {...paramState}/>;
      case "StepsTypeTag":
        return <StepsTypeTag {...paramState}/>;
      case "CustomAll":
        return <CustomAll {...paramState}/>;
      case "CustomAllFiles":
        return <CustomAllFiles {...paramState}/>;                
      default:
        return <TextInput {...paramState} />;
        
    }
  }
}

SwitchItems.defaultProps = {
  screen: "Layout",
  onBlurHandlerAction:()=>{}
}

export default SwitchItems;

 
